export class Kpimaster {
    public id: any;
    public kpi_name: string;
    public kpi_type: string;
    public product: any;
    public created_dt: Date;
    public created_by: string;
    public update_dt: Date;
    public updated_by: string;
    public measure_type: string;
    public kpi_status: string;
    public products: string[];
    public trans_field_value: string;
    public trans_field_name: string;
    public product_type: string;
    public productid: any;
    public kpi_calc_type: string;
    public custom_routine: string;
    public effective_date: Date;
    public product_category: any;
    public depndentKpis: any;
    public combo_string: string;
    public productName: string;
    public qualifyingrevenue: any;
    public combo_position: any;
    public combo_values: any;
    public dupli_cat: any;
    public dupli_pro: any;
    public edate: string;
    public wstat_string: string;
    public kpi_priority: any;
    public include_count: string;
    public include_revenue: string;
    public includecount: boolean = true;
    public includerevenue: boolean = true;
    public feed_type: string;
    public name: string;
    public stat: number;
    public chargeback_kpiid: any;
    public ch_kpiid: any;
    public chargeback_depndt_kpi_id: any;
    public chargeback_effective_date: any;
    
    constructor() {
        this.chargeback_kpiid = null;
        this.ch_kpiid = null;
        this.chargeback_depndt_kpi_id = null;
        this.chargeback_effective_date = null;
        this.name = null;
        this.feed_type = null;
        this.includecount = false;
        this.includerevenue = false;
        this.include_count = null;
        this.include_revenue = null;
        this.id = null;
        this.kpi_name = null;
        this.kpi_type = null;
        this.product = null;
        this.created_dt = null;
        this.created_by = null;
        this.update_dt = null;
        this.updated_by = null;
        this.measure_type = null;
        this.kpi_status = null;
        this.products = null;
        this.trans_field_value = null;
        this.trans_field_name = null;
        this.product_type = null;
        this.productid = null;
        this.kpi_calc_type = null;
        this.custom_routine = null;
        this.effective_date = null;
        this.product_category = null;
        this.depndentKpis = null;
        this.combo_string = null;
        this.productName = null;
        this.qualifyingrevenue = null;
        this.combo_position = null;
        this.combo_values = null;
        this.dupli_cat = null;
        this.dupli_pro = null;
        this.edate = "";
        this.wstat_string = null;
        this.kpi_priority = null;
    }
}
